import { render, staticRenderFns } from "./PageRow.vue?vue&type=template&id=7dcf79da&scoped=true"
import script from "./PageRow.vue?vue&type=script&lang=js"
export * from "./PageRow.vue?vue&type=script&lang=js"
import style0 from "./PageRow.vue?vue&type=style&index=0&id=7dcf79da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcf79da",
  null
  
)

export default component.exports